// removed by extract-text-webpack-plugin
module.exports = {"caseStudies":"_1oIp","caseStudyLinkTitle":"_1r0I","container":"_2p7p","caseStudyLinkProject":"_2iJ_"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Hero/CaseStudyLinks/styles.scss
// module id = 308
// module chunks = 0